import { Checkbox } from "antd";
import React from 'react';
import "./app_checkbox.css";
import AppFieldError from "../form/app_field_error/app_field_error";
class AppCheckboxGroup extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            checked: props.checked,
            id: props.id
        };
    }
    componentDidMount() { }
    onTextChange(val) {
        this.props.onChange(val);
    }
    render() {
        return (
            <div>
                {this.props.title}
                <div className="row m-0 w-100 mt-2">
                    {/* <Checkbox.Group checked={"true"} onChange={(e) => this.onTextChange(e)} style={{ display: "flex", flexDirection: "column" }}> */}
                    {this.props.options && this.props.options.length > 0 && this.props.options.map((x, idx) =>
                        <React.Fragment key={idx}>
                            <Checkbox checked={x.checked === "Yes" ? true : false} className="ml-0" disabled={x.disabled || false} key={idx} value={x.value} onChange={(e) => x.handleValueChange(x.getFormField ? x.getFormField: "", e.target.checked, x.childValue)}>{x.label}</Checkbox>
                            {x.checked === "Yes" && x.children && x.children}
                        </React.Fragment>
                    )}
                    {/* </Checkbox.Group> */}

                </div>
                {
                    this.props.error &&
                    <AppFieldError
                        text={this.props.errorMessage}
                    />
                }
            </div>
        );

    }
}

export default AppCheckboxGroup